import React from 'react';
import {useFilterContext} from '../../contexts/FilterContext';
import OfficesSelect from "../form/OfficesSelect";

const OfficesFilter = ({className, inputStyles}) => {

    const {name, filterValue, setFilterValue, updateURLParams } = useFilterContext();
    const handleInputChange = (value) => {
        setFilterValue(value);
        updateURLParams(name, value);
    };
    return (
        <div className={`filter ${className}`} style={inputStyles}>
            <OfficesSelect onChange={handleInputChange} defaultOfficeIds={filterValue}/>
        </div>
    );
};

export default OfficesFilter;
